import Button from './core/Button';
import { FormattedMessage } from 'react-intl';
import { useFormContext } from 'react-hook-form';
import { IconCheck } from '@/icons';
import { useMemo } from 'react';

interface FormActionProps {
  active: boolean;
  createMode: boolean;
  onCancel: () => void;
  onSubmit?: () => void;
  disabled?: boolean;
  isLoading?: boolean;
}

export const FormSubmitActions = ({
  active,
  createMode,
  onCancel,
  onSubmit,
  disabled,
  isLoading,
}: FormActionProps) => {
  const { formState } = useFormContext();
  const isDisabled = useMemo(() => {
    if (disabled) return true;

    if (createMode) {
      return !formState.isValid;
    }

    return !formState.isDirty || !formState.isValid;
  }, [createMode, formState.isValid, formState.isDirty, disabled]);

  if (!active) return null;

  return (
    <div className="mt-4 flex justify-end gap-2">
      <Button variant="ghost" onClick={onCancel} disabled={isLoading}>
        <FormattedMessage defaultMessage="Avbryt" />
      </Button>
      <Button
        type="submit"
        variant="filled"
        startIcon={<IconCheck aria-hidden="true" />}
        disabled={isDisabled}
        onClick={onSubmit}
        loading={isLoading}
      >
        <FormattedMessage
          defaultMessage="{type}"
          values={{
            type: createMode ? 'Spara' : 'Uppdatera',
          }}
        />
      </Button>
    </div>
  );
};
